export enum LayoutType {
  RightTwoColumns = 'right2col',
  RightOneColumn = 'right1col',
  LeftTwoColumns = 'left2col',
  LeftOneColumn = 'left1col',
}
